import { callBackendFunction } from "./paymentService";

export type SupportTicketType = "bug" | "support" | "suggestion";
export type SupportTicketSeverity = "low" | "medium" | "high" | "critical";
export type SupportTicketEnvironment = "dev" | "tst" | "prod" | "unknown";

export interface SupportTicketMetadata {
  page?: string;
  appVersion?: string;
  environment?: SupportTicketEnvironment;
  browser?: string;
  sentryEventId?: string;
}

export interface SubmitSupportTicketPayload {
  type: SupportTicketType;
  title: string;
  description: string;
  stepsToReproduce?: string;
  expectedResult?: string;
  actualResult?: string;
  severity?: SupportTicketSeverity;
  module?: string;
  contactEmail?: string;
  allowTechnicalContext?: boolean;
  metadata?: SupportTicketMetadata;
}

export interface SubmitSupportTicketResponse {
  success: boolean;
  ticketId: string;
  status: "open";
  githubSyncStatus: "synced" | "sync_failed";
  githubIssueNumber?: number | null;
  githubIssueUrl?: string | null;
  environment: SupportTicketEnvironment;
  emailNotificationStatus?: "pending" | "sent" | "failed";
}

export async function submitSupportTicket(payload: SubmitSupportTicketPayload) {
  return callBackendFunction<SubmitSupportTicketPayload, SubmitSupportTicketResponse>(
    "submitSupportTicket",
    payload
  );
}
